'use strict';

module.exports = function (Chart) {
  Chart.Line = function (context, config) {
    config.type = 'line';
    return new Chart(context, config);
  };
};